import Keycloak from "keycloak-js";

const keycloakInstance = new Keycloak("/keycloak.json");

interface CallbackOneParam<T1 = void, T2 = void> {
  (param1: T1): T2;
}

const isDocumentVisible = (): boolean => typeof document !== 'undefined' ? !document.hidden : true

const tryRefreshToken = async (): Promise<void> => {
  try {
    await keycloakInstance.updateToken(5)
  } catch (_e) {
    console.error("Failed to refresh token");
  }
}
/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */
const Login = (onAuthenticatedCallback: CallbackOneParam) => {
  keycloakInstance
    .init({ onLoad: "login-required" })
    .then(function (authenticated) {
      authenticated ? onAuthenticatedCallback() : alert("non authenticated");
    })
    .catch((e) => {
      console.dir(e);
      console.log(`keycloak init exception: ${e}`);
    });
    keycloakInstance.onTokenExpired = () => {
      if (!isDocumentVisible()) return
      tryRefreshToken()
    };

    if (typeof document !== 'undefined') {
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
          tryRefreshToken()
        }
      })
    }
};

const KeyCloakService = {
  CallLogin: Login,
  Instance: keycloakInstance,
};

export default KeyCloakService;
